// extracted by mini-css-extract-plugin
export var infoRow = "_p7-2";
export var labelContainer = "_p7-0";
export var rightInfo = "_p7-1";